export default __webpack_public_path__ + "static/media/pdfLogo.a32b296c.png";